import { connect } from 'react-redux';
import { getTenantId } from '../reducers/analyticsApp';
import Blank from '../components/Blank';

const mapStateToProps = (state) => ({
  tenantId: getTenantId(state),
});

export default connect(mapStateToProps)(Blank);
